export default __webpack_public_path__ + "static/media/fondo.daa9c052.jpg";